'use strict';

/**
 * Check for image errors on Lazysize event before image is unveiled
 *
 * @param {Object} img - jQuery DOM element
 */
function handleImageError(img) {
    if (!img.classList.contains('tile-image')) {
        return;
    }

    img.onerror = function () {
        img.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    };
}

document.addEventListener('lazybeforeunveil', function (e) {
    var img = e.target;
    handleImageError(img);
});
